import type { AnchorConfig } from "../api";

/**
 * Configured companion family names for a component tab, limited to families
 * that count in at least one selected country. No selection means all.
 */
export function componentFamilyNames(
    config: AnchorConfig | null | undefined,
    component: string,
    selectedCountries: string[]
): string[] {
    const families = config?.component_families?.[component] ?? [];
    const selected = new Set(selectedCountries.map((c) => c.toUpperCase()));
    return families
        .filter((f) => !f.countries || selected.size === 0 || f.countries.some((c) => selected.has(c)))
        .map((f) => f.name);
}

/** Append ": A, B, C" when family names are known. */
export function withFamilies(text: string, families: string[]): string {
    return families.length > 0 ? `${text}: ${families.join(", ")}` : text;
}
